export const LoadingMoto = () => {
  return (
    <div className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center gap-8">
      <div className="w-32 h-32 relative">
        <img 
          src="/lovable-uploads/819bdbdf-b90e-4866-97a3-374c01b38415.png" 
          alt="Logo Fan2Moto"
          className="w-full h-full object-contain"
        />
        <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-magazine-red rounded-full opacity-70" />
      </div>
      <div className="animate-pulse text-magazine-red font-semibold">
        Chargement...
      </div>
    </div>
  );
};